import { render, staticRenderFns } from "./registrationConsultationCh.vue?vue&type=template&id=f510f4ca"
import script from "./registrationConsultationCh.vue?vue&type=script&lang=js"
export * from "./registrationConsultationCh.vue?vue&type=script&lang=js"
import style0 from "./registrationConsultationCh.vue?vue&type=style&index=0&id=f510f4ca&prod&lang=less&scope=true"
import style1 from "./registrationConsultationCh.vue?vue&type=style&index=1&id=f510f4ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports